module.exports = __webpack_public_path__ + "img/no-forms.a6cff02c.svg";